import { render, staticRenderFns } from "./IconGoogleChevronUp.vue?vue&type=template&id=053171cf&"
import script from "./IconGoogleChevronUp.vue?vue&type=script&lang=ts&"
export * from "./IconGoogleChevronUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports